import React, { useState, useEffect, Fragment } from 'react'
import { Box, InputAdornment, TextField, IconButton } from '@material-ui/core'

import { makeStyles, useTheme } from '@material-ui/core/styles'

const dartmouthGreenColor = '#2D7638'
const themeGreenColor = '#39CFBA'

const useStyles = makeStyles(theme => ({
	// MuiInputLabel-root MuiInputLabel-formControl
	root: {
		position: 'relative',
		'& .MuiInputLabel-outlined ': {
			//color: '#39CFBA',
			fontFamily: 'Roboto Light,sans-serif'
		},
		'& .MuiInputLabel-formControl': {
			// color: '#39CFBA',
		},
		'& label.Mui-focused': {
			//color: themeGreenColor, *floating label color
		},
		'& .MuiInput-underline:after': {
			// borderBottomColor: dartmouthGreenColor,
		},
		'& $checked': {
			//color: '#62C370',
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: '0px',
			'& .MuiOutlinedInput-input': {
				fontFamily: 'Roboto Medium,sans-serif'
			},

			'& fieldset': {
				//borderColor: themeGreenColor,
			},
			'&:hover fieldset': {
				//borderColor: themeGreenColor,
			},
			'&.Mui-focused fieldset': {
				//borderColor: mingColor, * when focus feild
			}
		}
	},

	feildTextHint: {
		fontFamily: 'Roboto light,sans-serif',
		float: 'right',
		fontSize: '14px',
		position: 'absolute',
		right: 0,
		top: '-17px',
		color: '#2699FB'
	},
	textWrapper: {
		position: 'relative'
	},
	hiddenText: {
		color: 'transparent'
	}
}))

export default function MuiltInputBox(props) {
	const {
		name,
		label,
		value,
		row = 5,
		themeColor = 'primary',
		charLeft,
		error = null,
		limit = null,
		onChange
	} = props
	const classes = useStyles()

	return (
		<Box className={classes.root}>
			{charLeft > -1 && <Box className={classes.feildTextHint}>{`${charLeft} characters left`}</Box>}
			<TextField
				label={label}
				name={name}
				color={themeColor}
				multiline
				rows={row}
				value={value}
				onChange={onChange}
				variant='outlined'
				helperText={<span className={classes.hiddenText}>*</span>}
				{...(error && { error: true, helperText: error })}
			/>
		</Box>
	)
}

// defaultValue = { value }
